import { Sprite } from "pixi.js";

export class PIXIFlipBookSprite {
    sprite: Sprite
    width: number
    height:number
    vtiles: number
    htiles: number
    progress: number = 0
    speed: number = 1
}